import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  const faqs = [
    {
      question: "How often should I update my content?",
      answer: "We recommend updating your content at least monthly to keep your app fresh and engaging. Update your Calendar section regularly with new events, add new work to your portfolio, and refresh your About section as your career progresses."
    },
    {
      question: "What image formats are supported?",
      answer: "The platform supports JPG, PNG, and WebP formats. For best results, use high-resolution images (at least 1080px width). Keep file sizes under 5MB for optimal loading speeds."
    },
    {
      question: "Can I customize the app layout?",
      answer: "The app layout is standardized to ensure consistent user experience, but you can customize the content within each section. Focus on high-quality images, compelling text, and complete information to make your app stand out."
    },
    {
      question: "How do I preview my changes?",
      answer: "Use the \'Preview App\' button in the Content Management section or the \'App Preview\' link in the quick navigation. This shows you exactly how your content will appear to users on mobile devices."
    },
    {
      question: "What happens if I don't complete all required sections?",
      answer: "Your app will still function, but incomplete required sections (Profile, Promotion, About) may result in a less professional appearance. Complete all sections for the best user experience."
    },
    {
      question: "Can I have multiple social media accounts linked?",
      answer: "Yes, you can add multiple social media links in your Profile section. Make sure to use full URLs and verify that all links work correctly before saving."
    },
    {
      question: "How do I delete old events from my calendar?",
      answer: "In the Calendar section, click the delete button (trash icon) next to any event you want to remove. We recommend removing past events regularly to keep your calendar current."
    },
    {
      question: "What's the difference between artist types?",
      answer: "Your artist type (Music, Visual, Model, Actor) determines which work sections are available to you. Each type has customized fields relevant to that artistic discipline."
    }
  ];

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
          <Icon name="MessageCircleQuestion" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-xl font-semibold text-text-primary">Frequently Asked Questions</h3>
          <p className="text-text-secondary text-sm">Common questions and helpful answers</p>
        </div>
      </div>
      <div className="space-y-4">
        {faqs?.map((faq, index) => (
          <div key={index} className="border border-border rounded-lg">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-muted transition-colors"
            >
              <span className="font-medium text-text-primary pr-4">
                {faq?.question}
              </span>
              
              <Icon 
                name={expandedFAQ === index ? "ChevronUp" : "ChevronDown"} 
                size={20} 
                className="text-text-secondary flex-shrink-0"
              />
            </button>
            
            {expandedFAQ === index && (
              <div className="px-4 pb-4 border-t border-border bg-muted/30">
                <p className="text-text-secondary pt-4 leading-relaxed">
                  {faq?.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Contact Support */}
      <div className="mt-8 bg-accent/10 rounded-lg p-4 border border-accent/20">
        <div className="flex items-start space-x-3">
          <Icon name="Mail" size={20} className="text-accent mt-0.5" />
          <div>
            <h4 className="font-medium text-text-primary mb-1">Still need help?</h4>
            <p className="text-sm text-text-secondary mb-3">
              Our support team is here to assist you with any questions about managing your artist content.
            </p>
            <a 
              href="mailto:support@idartists.com"
              className="text-accent hover:text-accent/80 text-sm font-medium transition-colors"
            >
              Contact Support →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;